import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../components/Common/backBtn";
import InputRadioField from "../../../components/Common/inputRadioField";
import InputTextField from "../../../components/Common/inputTextField";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import SucessModal from "../../../components/Modal/SucessModal";
import { uploadToSpaces } from "../../Masters/Utils/uploadToSpaces";

const AddStoreLocationForm = ({ edit = false, view = false }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [checked, setChecked] = useState(true);

  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [success, setSuccess] = useState(false);

  console.log("watch", watch("status"));
  const getStoreData = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}healthsy-pharmacy/city-town-masters/get/${id}`
      )
      .then((res) => {
        const data = res.data;
        setValue("location", data.location);
        console.log("data.active", data.active);
        setValue("status", setChecked(data.active));
      })
      .catch((err) => {
        console.error(err);
        alert("Error fetching store location data");
      });
  };

  useEffect(() => {
    if (edit || view) getStoreData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit, view]);

  const onSubmit = async (fields) => {
    console.log("fields: ", fields);
    try {
      const payload = {
        location: fields.location,
        active: fields.active === "true" ? true : false,
      };
      console.log("payload: ", payload);

      if (edit) {
        const res = await axios.patch(
          `${process.env.REACT_APP_API_URL}healthsy-pharmacy/city-town-masters/update/${id}`,
          payload
        );
        if (res?.statusText === "OK") setSuccess(true);
        else alert("Update failed");
      } else {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}healthsy-pharmacy/city-town-masters/create`,
          payload
        );
        console.log("res: ", res);
        if (res.status === 200) setSuccess(true);
        else console.error("Create failed");
      }
    } catch (err) {
      console.error("Submit failed: ", err);
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Franchise programme", link: "" },
      {
        text: "city/town masters",
        link: "/franchise-programme/city-town-masters",
      },
      {
        text: edit
          ? "Edit city/town master"
          : view
            ? "View city/town master"
            : "Add New city/town master",
        link: "",
      },
    ],
    [edit, view]
  );

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="w-75 healthsyMasterBreadCrumbs"
                breadcrumbsList={breadcrumbsList}
              />
              <BackBtn navigatePath="/franchise-programme/city-town-masters" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form g-4 m-3">
              {/* Left Column */}
              <div className="col-md-6 d-flex flex-column gap-4">
                {/* Location */}
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="City / Town"
                  errorText="Please enter the city/town"
                  name="location"
                  placeholder="Enter City/Town"
                  disable={view}
                />
              </div>

              {/* Right Column */}
              <div className="col-6 row ">
                <label
                  className="form-label title mb-2 g-4"
                  style={{ color: "#4B4853" }}
                  htmlFor=""
                >
                  Active <span className="star">*</span>
                </label>
                <div className="d-flex">
                  <div className="form-check form-check-inline d-flex align-items-center me-3 mt-1">
                    <input
                      className="form-check-input me-3"
                      type="radio"
                      name="status"
                      id="status"
                      value={true}
                      checked={checked}
                      onClick={() => setChecked(true)}
                      {...register("active", { required: true })}
                    />
                    <label htmlFor="option-1" className="text-dark ">
                      Yes
                    </label>
                  </div>
                  <div className="form-check form-check-inline d-flex align-items-center mt-1">
                    <input
                      className="form-check-input me-3"
                      type="radio"
                      name="status"
                      id="status"
                      value={false}
                      checked={!checked}
                      onClick={() => setChecked(false)}
                      {...register("active", { required: true })}
                    />
                    <label htmlFor="option-2" className="text-dark">
                      No
                    </label>
                  </div>
                </div>
              </div>

              {/* Submit */}
              {!view && (
                <div className="m-5 text-center">
                  <button
                    type="submit"
                    className="btn btn-success"
                    style={{ border: "none" }}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal
          page={"/franchise-customers/city-town-masters"}
          name="new StoreLocation"
          post={edit ? "updated" : "added"}
          onClose={() => navigate("/franchise-customers/city-town-masters")}
        />
      )}
    </>
  );
};

export default AddStoreLocationForm;
